import { useMutation } from "@tanstack/react-query";
import { axiosApi } from "./axios";

const cancelMandate = async (billingEntityId: string) => {
  return axiosApi.post(`/payment/cancel/${billingEntityId}`);
};

export const useCancelMandate = () => {
  return useMutation({
    mutationFn: cancelMandate,
    onSuccess: () => {},
    onError: () => {},
  });
};

const retrieveBillingRequestFlow = async (billingEntityId: string) => {
  return axiosApi.post(`/payment/retrieve-billing-request-flow/${billingEntityId}`);
};

export const useRetrieveBillingRequestFlow = () => {
  return useMutation({
    mutationFn: retrieveBillingRequestFlow,
    onSuccess: () => {},
    onError: () => {},
  });
};
